"use client";

import React from "react";
import Button from "./Button";
import { useTranslations } from "next-intl";
import useFilterContext from "../hooks/useFilterContext";

const FilterResetButton: React.FC = () => {
  const t = useTranslations();
  const { clearFilterValues, isAnyFilterSet } = useFilterContext();

  return isAnyFilterSet ? (
    <div className="mt-2">
      <Button
        type="reset"
        className="color-blue fs-8"
        appearance="link"
        icon="restart"
        onClick={() => clearFilterValues()}
      >
        {t("delete_all_filters")}
      </Button>
    </div>
  ) : null;
};

export default FilterResetButton;
